/**
 * KitKeyframes — the three @keyframes the kit needs (skeleton shimmer, sheet
 * entrance, and the in-flight ring a media well spins), plus the one rule that
 * cannot be expressed inline either.
 *
 * `viNativeSpin` is deliberately NOT in the reduced-motion rule below: the
 * shimmer and the sheet entrance are decoration, and a spinner is the only
 * thing on screen saying the wait is still alive — freezing it would leave a
 * dead ring where the status was.
 * Keyframes and `:empty` cannot live in an inline style object, so they ship as
 * one tiny <style> with `viNative`-prefixed names; mounting it more than once
 * is harmless (identical rules).
 *
 * `.vi-native-panel:empty` is the dashboard's honesty rule made structural: a
 * module that data-gated itself away (a notice list with nothing to warn about)
 * renders nothing, and the panel around it must vanish with it rather than
 * leave a raised empty card on the page.
 */
const CSS = `
@keyframes viNativeShimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
@keyframes viNativeSheetIn { from { transform: translateY(14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
@keyframes viNativeSpin { to { transform: rotate(360deg); } }
@keyframes viNativeBreath { 0%, 100% { opacity: 0.45; } 50% { opacity: 1; } }
.vi-native-panel:empty { display: none; }
.vi-native-padding:empty, .vi-native-padding:has(> .vi-native-panel:empty:only-child) { display: none; }
@media (prefers-reduced-motion: reduce) {
  [style*="viNativeShimmer"], [style*="viNativeSheetIn"], [style*="viNativeBreath"] { animation: none !important; }
}
`;

export default function KitKeyframes() {
  return <style>{CSS}</style>;
}
